<template>
	<v-dialog v-model="isOpen" persistent max-width="800px">
	  <v-card elevation="1">
			<v-toolbar flat dense color="primary">
				<v-spacer></v-spacer>
				<v-toolbar-title>
					<span style="color: white"> 
						<span v-if="userId">Edit</span>
						<span v-else>Add</span> Member
					</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<div class="text-right pa-2">
				<v-icon color="white" @click="handleCancel">
					mdi-close
				</v-icon>
				</div>
			</v-toolbar>
		
			<v-form ref="form" @submit.prevent="handleSubmit();" method="post" enctype="multipart/form-data">
				<v-card-text>
					<v-row>
						<v-col>
							<v-text-field 
								v-model="values.firstName"
								label="First Name"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.lastName"
								label="Last Name"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field 
								v-model="values.email"
								label="Email Address*"
								:required="true"
								:rules="emailRules"
								:readonly="!!userId"
							/>
						</v-col>

						<v-col>
							<v-btn
								text
								small
								color="primary"
								v-if="userId && !resetPassword.toggle"
								@click="resetPassword.toggle = !resetPassword.toggle"
							>
								Click here to reset password
							</v-btn>
							<v-row v-else align="center">
								<v-col cols="7">
									<v-text-field 
										v-model="values.password"
										:type="resetPassword.visibility ? 'text' : 'password'"
										label="Password"
										:append-icon="resetPassword.visibility ? 'mdi-eye-off' : 'mdi-eye'"
										@click:append="resetPassword.visibility = !resetPassword.visibility"
										readonly
										:loading="resetPassword.isSubmitting"
										:error-messages="resetPassword.errorMsg"
										:success-messages="resetPassword.successMsg"
									/>
								</v-col>
								<v-col cols="4">
									<v-btn small color="primary" @click="generatePassword">
										Reset Password
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-select
								v-model="values.group"
								:items="groupOptions.data"
								:loading="groupOptions.isLoading"
								item-text="val"
								item-value="db_val"
								label="Group"
								return-object
								style="font-size: 14px"
							/>
						</v-col>
						<v-col>
							<v-text-field
								v-model="values.noOfMachines"
								label="Number of Machines"
								type="number"
								:min="0"
								:max="100"
							/>
						</v-col>
						<v-col>
							<v-checkbox
								v-model="values.bypassSecurity"
								label="Bypass Security"
								color="primary"
								hide-details
								class="mt-0"
							/>
							<v-checkbox
								v-model="values.isMFA"
								label="MFA"
								color="primary"
								hide-details
								class="mt-0"
							/>
							<!-- value="yes" -->
							<!-- @click="searchAffinity()" -->
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field 
								v-model="values.companyName"
								label="Company Name*"
								required
								:rules="companyRules"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.clientName"
								label="Client Name (Agencies Only)"
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field 
								v-model="values.streetAddress"
								label="Street Address"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.city"
								label="City"
							/>
						</v-col>
						<v-col>
							<v-select
								v-model="values.state"
								:items="stateOptions.data"
								:loading="stateOptions.isLoading"
								item-text="val"
								item-value="db_val"
								label="State"
								return-object
								style="font-size: 14px"
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field 
								v-model="values.division"
								label="Division"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.zipCode"
								label="Zip Code"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.phone"
								label="Phone"
							/>
						</v-col>
						<v-col>
							<v-text-field 
								v-model="values.fax"
								label="Fax"
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-select
								v-model="values.countryName"
								:items="countryOptions"
								:loading="rawData.isLoading"
								item-text="val"
								item-value="db_val"
								label="Country"
								return-object
								chips
								small-chips
								persistent-hint
								style="font-size: 14px"
							/>
						</v-col>
			
						<v-col>
							<MultiSelectDropdown
								v-model="values.mediaChannel"
								:items="mediaChannelOptions"
								:loading="rawData.isLoading"
								label="Media Channel"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>

						<v-col>
							<MultiSelectDropdown
								v-model="values.audience"
								:items="audienceOptions"
								:loading="rawData.isLoading"
								label="Audience"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<MultiSelectDropdown
								v-model="values.sectors"
								:items="sectorOptions"
								:loading="allSectors.isLoading"
								label="Sector"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
						<v-col>
							<MultiSelectDropdown
								v-model="values.categories"
								:items="categoryOptions"
								:loading="allSectors.isLoading"
								label="Category"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
			
						<v-col>
							<MultiSelectDropdown
								v-model="values.subCategories"
								:items="subCategoryOptions"
								:loading="allSectors.isLoading"
								label="Sub Category"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<MultiSelectDropdown
								v-model="values.powerSearchExclude"
								:items="powerSearchExcludeOptions"
								:loading="rawData.isLoading"
								label="Exclude from Power Search"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
						<v-col>
							<MultiSelectDropdown
								v-model="values.powerSearchAdditional"
								:items="powerSearchAdditionalOptions"
								:loading="rawData.isLoading"
								label="Additional Fields for Power Search"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<MultiSelectDropdown
								v-model="values.dashboardPermissions"
								:items="dashboardPermissionOptions"
								:loading="rawData.isLoading"
								label="Dashboard Permissions"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>
						<v-col>
							<MultiSelectDropdown
								v-model="values.pagePermissions"
								:items="pagePermissionOptions"
								:loading="rawData.isLoading"
								label="Page Permissions"
								item-text="val"
								item-value="db_val"
								:visible-chips="3"
							/>
						</v-col>					
					</v-row>

					<v-row>
						<v-col>
							<v-select
								v-model="values.sendEmail"
								:items="sendEmailOptions"
								:loading="rawData.isLoading"
								item-text="val"
								item-value="db_val"
								label="Send Email"
								return-object
								persistent-hint
								style="font-size: 14px"
							/>
						</v-col>
						<v-col>
							<v-row v-if="values.sendEmail.val=='Company Usage Report'">
								<v-col>
									<v-container>
                    <v-menu
                      v-model="fromDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="values.companyUsageFromDate"
                          label="From Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="values.companyUsageFromDate"
                        locale="en-in"
                        no-title
                        scrollable
                        @input="fromDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-container>
								</v-col>
								<v-col>
									<v-container>
                    <v-menu
                      v-model="toDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="values.companyUsageToDate"
                          label="To Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="values.companyUsageToDate"
                        locale="en-in"
                        no-title
                        scrollable
                        @input="toDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-container>
								</v-col>
							</v-row>
						</v-col>
					</v-row>

					<!-- Company Usage Report -->

					<v-row>
						<v-col>
							<v-select
								v-model="values.annotationToolPermission"
								:items="annotationToolPermissionOptions"
								:loading="rawData.isLoading"
								item-text="val"
								item-value="db_val"
								label="Annotation Tool Link Permission"
								return-object
								persistent-hint
								style="font-size: 14px"
							/>
						</v-col>
						<v-col>
							<v-select
								v-model="values.aiAnalysisPermission"
								:items="aiAnalysisPermissionOptions"
								:loading="rawData.isLoading"
								item-text="val"
								item-value="db_val"
								label="AI Analysis Link Permission"
								return-object
								persistent-hint
								style="font-size: 14px"
							/>
						</v-col>
						<v-col>
							<v-select
								v-model="values.senderDomainPersmission"
								:items="senderDomainPermissionOptions"
								:loading="rawData.isLoading"
								item-text="val"
								item-value="db_val"
								label="Sender Domain Permission"
								return-object
								persistent-hint
								style="font-size: 14px"
							/>
						</v-col>
					</v-row>

					<v-row v-if="userId">
						<v-col>
							<v-checkbox
								v-model="values.applyToAllMedia"
								color="primary"
								hide-details
							>
								<template #label>
									<div>
										<div>
											Update for all {{ values.companyName }} users
										</div>
										<div style="font-weight: normal; font-size: 12px;">
											[Media Channels, Audience, Sector/Category/Sub Category, Power Search, Dashboard Permissions]
										</div>
									</div>
								</template>
							</v-checkbox>
						</v-col>
						<v-col>
							<v-checkbox
								v-model="values.applyToAllGroup"
								color="primary"
								hide-details 
							>
								<template #label>
									<div>
										<div>
											Update for all {{ values.companyName }} users
										</div>
										<div style="font-weight: normal; font-size: 12px;">
											[Group, Number of Machines, Bypass Security]
										</div>
									</div>
								</template>
							</v-checkbox>
						</v-col>
					</v-row>
				</v-card-text>
		
				<v-card-actions class="justify-end">
					<v-spacer></v-spacer>
					<v-btn v-if="!userId" @click="handleSaveAndAddMore" small color="primary">
						save and add more
					</v-btn>
					<v-btn type="submit" small color="primary">
						save
					</v-btn>
					<v-btn color="grey" small @click="handleCancel">
						cancel
					</v-btn>
				</v-card-actions>
			</v-form>
	  </v-card>
	</v-dialog>
</template>

<script>
import MultiSelectDropdown from "@/views/dashboard/component/MultiSelectDropdown";

export default {
  name: "MemberForm",
  components: { MultiSelectDropdown },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
		userId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
			name: "",
      isLoading: false,
			memberDetails: null,
			fromDateMenu: false,
			toDateMenu: false,
			resetPassword: {
				visibility: false,
				toggle: false,
				isSubmitting: false,
				errorMsg: '',
				successMsg: '',
			},
      values: {
				firstName: "",
				lastName: "",
				email: "",
				password: "",

				group: { "db_val": "None", "val": "None" },
				sendEmail: { "db_val": "None", "val": "None" },
				noOfMachines: 1,
				bypassSecurity: false,
				isMFA: false,

				companyName: "",
				clientName: "",
				streetAddress: "",
				city: "",
				state: "",
				division: "",
				zipCode: "",
				phone: "",
				fax: "",

				countryName: null,
        mediaChannel: [],
        sectors: [],
        categories: [],
        subCategories: [],
				audience: [],
				powerSearchExclude: [],
				powerSearchAdditional: [],
				dashboardPermissions: [],
				pagePermissions: [],
				annotationToolPermission: null,
				aiAnalysisPermission: null,
				senderDomainPersmission: null,
				applyToAllMedia: false,
				applyToAllGroup: false,
				companyUsageFromDate: null,
				companyUsageToDate: null,
      },
			rawData: {
        isLoading: false,
        data: [],
      },
			groupOptions: {
        isLoading: false,
        data: [],
      },
      allSectors: {
        isLoading: false,
        data: [],
      },
			stateOptions: {
        isLoading: false,
        data: [],
      },
			countryOptions: [],
      mediaChannelOptions: [],
			audienceOptions: [],
			powerSearchExcludeOptions: [],
			powerSearchAdditionalOptions: [],
			dashboardPermissionOptions: [],
			pagePermissionOptions: [],
			annotationToolPermissionOptions: [
				{ "db_val": true, "val": "Yes" },
				{ "db_val": false, "val": "No" }
			],
			aiAnalysisPermissionOptions: [
				{ "db_val": true, "val": "Yes" },
				{ "db_val": false, "val": "No" }
			],
			senderDomainPermissionOptions: [
				{ "db_val": true, "val": "Yes" },
				{ "db_val": false, "val": "No" }
			],
			sendEmailOptions: [],
			emailRules: [
				v => !!v?.trim() || "Enter email",
				v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Invalid email"
			],
			companyRules: [
        (v) => {
          return !!v?.trim() || "Enter company name"
        },
      ],
    };
  },
	computed: {
		sectorOptions: function () {
			return this.generateDropdownOptions(this.allSectors.data);
    },
		categoryOptions: function () {
			const selectedSectorIds = {}
			this.values.sectors?.forEach(({db_val})=>{
				selectedSectorIds[db_val] = 1
			})
			let catOptions = []
			for(let sect of this.allSectors.data){
				if(selectedSectorIds[sect.name]){
					catOptions = [...catOptions, ...this.generateDropdownOptions(sect.children)]
				}
			}
			return catOptions
    },
		subCategoryOptions: function () {
			const selectedCategoryIds = {}
			this.values.categories?.forEach(({db_val})=>{
				selectedCategoryIds[db_val] = 1
			})
			let subCatOptions = []
			for(let sect of this.allSectors.data){
				for(let cat of (sect.children || [])){
					if(selectedCategoryIds[cat.name]){
						subCatOptions = [...subCatOptions, ...this.generateDropdownOptions(cat.children)]
					}
				}
			}
			return subCatOptions
    },
	},
  watch: {
		isLoading(val) {
			this.$emit("loading", val);
    },
		'rawData.data'(data) {
			if(!data){
				return;
			}
			this.countryOptions = this.generateDropdownOptions2(data?.['Country'])
			this.mediaChannelOptions = this.generateDropdownOptions2(data?.['Media Channels'])
			this.audienceOptions = this.generateDropdownOptions2(data?.['Audience'])
			this.powerSearchExcludeOptions = this.generateDropdownOptions2(data?.['Exclude from Power Search'])
			this.powerSearchAdditionalOptions = this.generateDropdownOptions2(data?.['Additional Fields For Power Search'])
			this.dashboardPermissionOptions = this.generateDropdownOptions2(data?.['Dashboard Permissions'])
			this.pagePermissionOptions = this.generateDropdownOptions2(data?.['Page Permission'])
			this.sendEmailOptions = this.generateDropdownOptions2(data?.['Send Email'])
			// this.annotationToolPermissionOptions = this.generateDropdownOptions2(data?.['Anotation Tool Link Permission'])
			// this.aiAnalysisPermissionOptions = this.generateDropdownOptions2(data?.['AI Analysis Link Permission'])
    },
		// Filter selected Categories on change of Category options
		'categoryOptions'(data) {
			if(this.allSectors.isLoading){
				return
			}
			// Filter selected categories
			const selectedCategoryIds = {}
			data.forEach(({db_val})=>{
				selectedCategoryIds[db_val] = 1
			})
			this.values.categories = this.values.categories?.filter(cat=>{
				return selectedCategoryIds[cat.db_val]
			})
		},
		// Filter selected SubCategories on change of SubCategory options
		'subCategoryOptions'(data) {
			if(this.allSectors.isLoading){
				return
			}
			// Filter selected subCategories
			const selectedSubcategoryIds = {}
			data.forEach(({db_val})=>{
				selectedSubcategoryIds[db_val] = 1
			})
			this.values.subCategories = this.values.subCategories?.filter(cat=>{
				return selectedSubcategoryIds[cat.db_val]
			})
		},
		'memberDetails'(data) {
			this.generateEditFormData(data)
		},
  },

  methods: {
		generatePassword() {
      const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
			const lower = "abcdefghijklmnopqrstuvwxyz"
			const nums = "0123456789"
			const special = "!@#$%^&*()"
			const all = upper + lower + nums + special

			// Pick 1 of each category
			let pass = [
				upper[Math.floor(Math.random() * upper.length)],
				lower[Math.floor(Math.random() * lower.length)],
				nums[Math.floor(Math.random() * nums.length)],
				special[Math.floor(Math.random() * special.length)]
			]

			// Fill the rest to length 12
			while (pass.length < 12) {
				pass.push(all[Math.floor(Math.random() * all.length)])
			}

			// Shuffle
			pass = pass.sort(() => Math.random() - 0.5).join("")

			this.values.password = pass
			this.resetPassword.visibility = true // show after generation
			// this.handleChangePassword(pass)
			
    },

		// async handleChangePassword(password) {
    //   this.resetPassword.isSubmitting = true;
    //   try {
    //     const changePasswordUrl = this.$url("CHANGE_PASSWORD_URL");
		// 		const response = await this.$fetch({
		// 			requiresAuth: true,
		// 			operation: "edit",
		// 			vueScope: this,
		// 		}).post(changePasswordUrl, {
		// 			email: this.values.email,
		// 			password
		// 		});
		// 		if(response.status===200){
		// 			this.resetPassword.successMsg = "Password changed successfully";
		// 			this.resetPassword.errorMsg = "";
		// 		}
    //   } catch (error) {
    //     console.error(error);
    //     this.resetPassword.errorMsg = "Something went wrong";
		// 			this.resetPassword.successMsg = "";
    //   } finally {
    //     this.resetPassword.isSubmitting = false;
    //   }
    // },
		handleSaveAndAddMore(){
			this.handleSubmit(true)
		},
    async handleSubmit(addMore) {
			if(!this.$refs.form.validate()){
				return
			}
			this.isLoading = true;
      let data = {
				"firstName": this.values.firstName,
				"lastName": this.values.lastName,
				"email": this.values.email,
				"password": this.values.password,
				"companyName": this.values.companyName,
				"clientName": this.values.clientName,
				"streetAddress": this.values.streetAddress,
				"city": this.values.city,
				"state": this.values.state?.val,
				"division": this.values.division || '',
				"zipCode": this.values.zipCode,
				"phone":this.values.phone,
				"fax": this.values.fax,
				"bypass": this.values.bypassSecurity ? 1 : 0,
				"is_mfa": this.values.isMFA ? 1 : 0,
				"plevel": this.values.group?.val,
				"countryName": this.values.countryName?.val || '',
				"mChannelName": this.values.mediaChannel?.map(e=>e.val),
				"mPanelName": this.values.audience?.map(e=>e.val),
				"sectorName": this.values.sectors?.map(e=>e.val),
				"category_name": this.values.categories?.map(e=>e.val),
  			"subcategory_name": this.values.subCategories?.map(e=>e.val),
				"edc_name": this.values.dashboardPermissions?.map(e=>e.val),
				"page_permission": this.values.pagePermissions?.map(e=>e.val),
				"additional_field": this.values.powerSearchAdditional?.map(e=>e.val),
				"power_search": this.values.powerSearchExclude?.map(e=>e.val),
				"number_machines": this.values.noOfMachines,
				"annotation_tool": this.values.annotationToolPermission?.db_val
					? "anotation_tool_link" : "",
				"analysis_link": this.values.aiAnalysisPermission?.db_val
					? "ai_analysis_link" : "",
				"sender_domain": this.values.senderDomainPersmission?.db_val
					? "sender_domain_permission" : "",
				"applyToAllMedia": this.values.applyToAllMedia ? 1 : 0,
				"applyToAllGroup": this.values.applyToAllGroup ? 1 : 0,
				"sendemail": this.values.sendEmail?.val,
				"from_date": this.values.companyUsageFromDate,
				"to_date": this.values.companyUsageToDate,
      };
      try {
        let clientProfileUrl = this.$url("CLIENT_PROFILE");
        if(this.userId){
					data.userID = this.userId
					await this.$fetch({
						requiresAuth: true,
						operation: "view",
						vueScope: this,
					}).put(clientProfileUrl, data);
				}else{
					await this.$fetch({
						requiresAuth: true,
						operation: "view",
						vueScope: this,
					}).post(clientProfileUrl, data);
				}
				this.$emit("success", addMore);
      } catch (error) {
				let errMsg = error.response?.data?.message || "Something went wrong!"
				if(errMsg.includes("data already exists")) {
					errMsg = "A user with this email address already exists."
				}
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: errMsg,
        });
      } finally {
        this.isLoading = false;
      }
    },

    handleCancel() {
      this.$emit("close");
    },

		generateDropdownOptions(list){
      if(!list) return []
      return list.map(({name})=>({db_val: name, val: name }));
    },
		generateDropdownOptions2(list){
      if(!list) return []
      return list.map((val)=>({db_val: val, val }));
    },
		/**
		 * Generate dropdown options (selected items), while edit Profile
		 * @param dropdownOptions - type {val, db_val}[],
		 * @param selectedItems - Type String[], 
		 */
		generateSelectedOptions(dropdownOptions, selectedItems){
			return dropdownOptions?.filter(option=>{
				return selectedItems?.find(item=>item==option.val)
			}) || []
    },

		async fetchRawData() {
      this.rawData.isLoading = true;
      try {
        let rawDataUrl = this.$url("CLIENT_RAW_DATA");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(rawDataUrl);
				delete response.data?.['Sector/Category/Sub Category']
				this.rawData.data = response.data;
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.rawData.isLoading = false;
      }
    },

		async fetchGroups() {
      this.groupOptions.isLoading = true;
      try {
        let rawDataUrl = this.$url("GROUPS_URL");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(rawDataUrl);
        this.groupOptions.data = response.data?.data?.map((val)=>({db_val: val, val: val }))
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.groupOptions.isLoading = false;
      }
    },

		async fetchStates() {
      this.stateOptions.isLoading = true;
      try {
        let statesUrl = this.$url("CLIENT_STATES_URL");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(statesUrl);
        this.stateOptions.data = response.data?.data?.map((val)=>({db_val: val, val: val }))
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.stateOptions.isLoading = false;
      }
    },

		async fetchAllSectors() {
      this.allSectors.isLoading = true;
      try {
        const sectorApi = this.$url("ALLSECTORS") + "?type=sector";
        const response = await this.$fetch({
					requiresAuth: true,
					operation: "view",
					vueScope: this,
				}).get(sectorApi);
				this.allSectors.data = response.data?.payload || [];

				// let cachedData = localStorage.getItem('allSectors')
        // if(!cachedData){
				// 	const response = await this.$fetch({
				// 		requiresAuth: true,
				// 		operation: "view",
				// 		vueScope: this,
				// 	}).get(sectorApi);
				// 	cachedData = JSON.stringify(response.data?.payload || [])
				// 	localStorage.setItem('allSectors', cachedData)
				// }
				// cachedData = JSON.parse(cachedData)
				// this.allSectors.data = cachedData || [];
      } catch (error) {
        console.error(error);
      } finally {
        this.allSectors.isLoading = false;
      }
    },

		async fetchMemberDetails() {
      this.isLoading = true;
      try {
        const clientProfileUrl = this.$url("CLIENT_PROFILE");
				const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(clientProfileUrl, { params: { userID: this.userId } });
				if(response.status===200){
					this.memberDetails = response.data
				}
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

		generateEditFormData(data){
			if(!data){
				return
			}
			this.values.firstName = data.Profile.firstName
			this.values.lastName = data.Profile.lastName
			this.values.email = data.Profile.emailAddress
			this.values.noOfMachines = data.Profile.number_machines
			this.values.bypassSecurity = data.Profile.bypass
			this.values.isMFA = data.Profile.is_mfa
			this.values.applyToAllMedia = data.Profile.applyToAllMedia
			this.values.applyToAllGroup = data.Profile.applyToAllGroup
			this.values.companyName = data.Profile.companyName
			this.values.clientName = data.Profile.clientName
			this.values.streetAddress = data.Profile.streetAddress
			this.values.city = data.Profile.city
			// this.values.state = data.Profile.state
			this.values.division = data.Profile.country
			this.values.zipCode = data.Profile.zipCode==0 ? '' : data.Profile.zipCode
			this.values.phone = data.Profile.phone==0 ? '' : data.Profile.phone
			this.values.fax = data.Profile.fax

			this.values.mediaChannel = this.generateDropdownOptions2(data["Media Channels"])
			this.values.audience = this.generateDropdownOptions2(data["Audience"])
			this.values.powerSearchExclude = this.generateDropdownOptions2(data["Exclude from Power Search"])
			this.values.powerSearchAdditional = this.generateDropdownOptions2(data["Additional Fields For Power Search"])
			this.values.dashboardPermissions = this.generateDropdownOptions2(data["Dashboard Permissions"])
			this.values.pagePermissions = this.generateDropdownOptions2(data["Page Permission"])
			
			this.values.sectors = this.generateDropdownOptions2(data["sector"])
			this.values.categories = this.generateDropdownOptions2(data["category"])
			this.values.subCategories = this.generateDropdownOptions2(data["subcategory"])
			// Single select fields
			this.values.countryName = this.generateDropdownOptions2(data["Country"])?.[0]
			this.values.aiAnalysisPermission = data["AI Analysis Link Permission"]?.[0]?.length 
				? this.aiAnalysisPermissionOptions[0] 
				: this.aiAnalysisPermissionOptions[1]
			this.values.annotationToolPermission = data["Anotation Tool Link Permission"]?.[0]?.length 
				? this.annotationToolPermissionOptions[0] 
				: this.annotationToolPermissionOptions[1]
			this.values.senderDomainPersmission = data["Sender Domain Allow"]?.[0]?.length 
				? this.senderDomainPermissionOptions[0] 
				: this.senderDomainPermissionOptions[1]
			this.values.group = this.generateDropdownOptions2(data["plevel"])?.[0]
			this.values.state = data.Profile.state 
				? {val: data.Profile.state, db_val: data.Profile.state}
				: null
		}
  },
	created() {
    this.fetchRawData();
    this.fetchGroups();
    this.fetchStates();
		this.fetchAllSectors();
		if (this.userId) {
			this.fetchMemberDetails();
		}else{
			this.generatePassword()
		}
  },
};
</script>
